import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';

const Acuity = () => (
  <Fragment>
    <Helmet>
      <script src="https://embed.acuityscheduling.com/js/embed.js" />
    </Helmet>
    <iframe title="acuity" src="https://app.acuityscheduling.com/schedule.php?owner=11311034&appointmentType=9954992" width="100%" height="800" frameBorder="0" />
  </Fragment>
);
export default Acuity;
